import { CustomerInvoicesModule } from '@/shared';

export default CustomerInvoicesModule;
